<template>
<div>
    <b-overlay
        :show="ordereditbusy"
        rounded
        variant="white"
        blur="2px" 
        opacity="0.9"
        spinner-variant="bruvis"
        class="d-inline-block w-100"
        style="inset:0px;"
    >
        <table 
            class="table orders-table mb-0" 
            sticky-header="true" 
            v-if="order.length > 0"
        >
            <tbody>
                <template v-for="(zk,idx) in order">
                    <tr :key="zk" :class="(zk.quant==0)?'alert-danger text-danger':'text-black'" v-if="menu_dishes[zk.menu_rn]">
                        <td class="wrdwrp" :id="'item_'+idx">{{zk.menu}}
                            <template v-if="zk.comments">
                                    <b-badge class="ml-1" variant="warning" v-if="zk.comments.split(';')[0]"> {{zk.comments.split(';')[0]}}</b-badge>
                                    <template v-if="zk.comments.split(';')[1]">
                                      <b-badge  class="ml-1" variant="warning" v-for="(cm,cmind) of zk.comments.split(';')[1].split(',')" :key=cmind>{{cm}}</b-badge>
                                    </template>  
                                  </template>      

                        </td>
                        <td class="align-top" width=1><!--@click="zk.quant=0,recalcAmountSum()" -->
                            <b-icon icon="trash" 
                                @click="setItemQuant(zk.menu_rn,0)"
                                title="Видалити" 
                                variant="" 
                                class="h4 m-0" 
                                role="button">
                            </b-icon>
                        </td>
                        <td width=1>
                            <template v-if="!(salepoint.onlyOnePos && (dishes[zk.menu_rn]).complex)">
                                <template v-if="(dishes[zk.menu_rn]).minportion===1">
                                    <SpinbuttonManual
                                        :id="zk.menu_rn+'_quant'" 
                                        :value="zk.quant"
                                        @input="setItemQuant(zk.menu_rn,$event)"
                                    />
                                </template>    
                                <template v-else>
                                    <b-form-spinbutton 
                                        v-model="zk.quant"
                                        @change="recalcAmountSum()" 
                                        min="0" max="100" size="sm" :step="(dishes[zk.menu_rn]).minportion"
                                        inline>
                                    </b-form-spinbutton>
                                </template>    

                            </template>

                        </td>
                    </tr>

                    <tr :key="zk" class="alert-warning text-secondary" v-else>
                        <td class="wrdwrp">{{zk.menu}}</td>
                        <td class="align-top" width=1>-</td>
                        <td width=1 class="text-center">x {{zk.quant}}</td>
                    </tr>


                </template>

                <tr >
                    <td colspan="3" class="text-right">
                        <b-button @click="openSimpleMenu()" class="btn btn-bruvis m-0">
                             <b-icon icon="plus-circle" class="mr-1"/>Додати страву
                        </b-button>
                    </td>
                </tr>  

                <tr class="border-top border-bottom" v-if="!salepoint.hidePrice">
                    <td>До сплати</td>
                    <td colspan="2" class="text-right" :class="(exceed)?'text-danger':''">{{amount_sum | toCurrency}}</td>
                </tr>  
                <tr class="pb-0">
                    <td colspan="3" align="right" class="pb-0">
                        <template v-if="exceedCardLimit">
                            <b-button 
                                class="btn btn-danger m-1 ml-auto"
                                disabled
                            >
                                <b-icon icon="exclamation-triangle-fill" class="mr-1"/>Лімиіт перевищено
                            </b-button>
                        </template>    
                        <template v-else-if="exceed">
                            <b-button 
                                class="btn btn-danger m-1 ml-auto"
                                disabled
                            >
                                <b-icon icon="exclamation-triangle-fill" class="mr-1"/>Недостатньо балансу
                            </b-button>
                        </template>    
                        <template v-else>
                            <b-button 
                                class="btn btn-success m-1 ml-auto"
                                @click="editOrder()"
                            >
                                <b-icon icon="check2" class="mr-1"/>Зберегти
                            </b-button>
                        </template>
                        
                        <b-button 
                            class="btn btn-bruvis m-1"
                            @click="$emit('close')"
                        >
                            <b-icon icon="x" class="mr-1"/>Відмінити
                        </b-button>
                    </td>
                </tr>        
            </tbody>        
        </table>
    </b-overlay>

     <b-modal id="simplemenu" hide-header-close- 
        centered scrollable size="lg" :no-close-on-backdrop="true"
        hide-footer-
        @hidden="selected=[]"
    >
        <template #modal-title>
            <b-icon icon="bag-plus" class="rounded bg-success p-1" variant="light" font-scale="1.3"></b-icon> <span class="p-2 h5 mr-auto">Що додати до замовлення?</span>
        </template>
        
        <b-form-select
            v-if="Object.keys(menu_categories).length > 0"
            v-model="catIndex"
        >
            <!--            :class="(Object.keys(menu_categories).length > 1)?'d-block d-md-none':'d-none'"-->
            <template v-for="(ct,ctind) of  Object.keys(menu_categories)">
                <b-form-select-option 
                    :key="ctind" 
                    :value="ct"
                >
                    {{(menu_categories[ct]).mnemo}}
                </b-form-select-option>
            </template>

        </b-form-select>

        <b-form-group class="ml-3 mt-3">
            <b-form-checkbox
                v-for="option in menu_filtered"
                v-model="selected"
                :key="option.rn"
                :value="option.rn"
                name="dishes"
                :disabled="oarr.includes(option.rn) || (salepoint.onlyOnePos && dishes[option.rn] && (dishes[option.rn]).complex && (complexlimit > 0  || complexlimitselected > 0) && !selected.includes(option.rn))"
                :class="(salepoint.onlyOnePos && dishes[option.rn] && (dishes[option.rn]).complex && (complexlimit > 0  || complexlimitselected > 0) && !selected.includes(option.rn))?'alert-danger':''"
            >
                {{ option.mnemo }}
            </b-form-checkbox>
        </b-form-group>

        <!--Selected: {{selected}}-->

        <!--template v-for="(dish,index2) of menu_filtered">  
            <li :key="index2">{{dish.mnemo}}</li>
        </template-->
        <template #modal-footer>
            <div class="w-100">
                <b-button
                    variant="bruvis"
                    class="float-right ml-2"
                    @click="$bvModal.hide('simplemenu')"
                >
                    <b-icon icon="x" class="mr-1"/>Відмінити
                </b-button>
                <b-button
                    variant="success"
                    :disabled="selected.length==0"
                    class="float-right ml-2"
                    @click="addToOrder(),$bvModal.hide('simplemenu')"
                >
                    <b-icon icon="check2" class="mr-1"/>Додати до замовлення
                </b-button>
            </div>
        </template>

    </b-modal>

</div>
</template>

<script>

import SpinbuttonManual from './spinbuttonmanual.vue'

export default {
  name: 'EditPayedOrder',
  components: {
    SpinbuttonManual
  },
  props: {
    order2edit: {
      type: Object,
      required: true
    },
    sumlimit: {
      type: Object,
      required: true
    },
    cardlimit: {
      type: Object,
      required: true
    },
    dishes: {
      type: Object,
      required: true
    },
    salepoint: {
      type: Object,
      required: true
    },
    menu: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    ordereditbusy: false,
    order: [],
    order_filtered: [],
    oarr: [],
    amount_sum: 0,
    menu_dishes: [],
    menu_filtered: [],
    menu_categories: [],
    catIndex: 0,
    selected: [],
    exceed: false,
    exceedCardLimit: false,
    complexlimit: 0,
    complexlimitselected: 0
  }),
  mounted(){
    //this.order = this.order2edit
    this.menu_dishes = this.menu.dishes
    this.menu_categories = this.menu.categories
    this.catIndex = Object.keys(this.menu_categories)[0]
    var allExist = true
    this.order2edit.specs.forEach((itm) => {
        this.order.push({'rn':itm.rn,'menu_rn' : itm.menu_rn, 'menu': itm.menu, 'quant':itm.quant, 'price': itm.price, 'comments': itm.comments})
        if(!this.menu_dishes[itm.menu_rn]) 
            allExist = false
        
        //console.log((this.dishes[itm.rn]).price + 'x' +itm.quant )
        //this.amount_sum += this.dishes[itm.rn].price * itm.quant
    })
   
    
    this.recalcAmountSum()
    if(!allExist) this.$toasted.info('Увага! Деякі страви з вашого замовлення тимчасово відсутні').goAway(5000)
  },
  methods:{
    editOrder(){
        this.ordereditbusy = true
        this.order_filtered = this.order.filter(item => item.quant > 0)
        //console.log(this.order2edit)

        if(this.order_filtered.length > 0){
            this.$axios.post('', {"action":'editpayedorder',"rn":this.order2edit.rn , "specs":this.order_filtered} )
            .then((response) => {
               if(response.data.success != false && response.data.success != 'false'){
                    this.$emit('onsuccess')
                    this.ordereditbusy = false
                    this.$toasted.success('Замовлення оновлено').goAway(2000)
                    this.$emit('close')
                }else{
                    if(response.data.error=="auth" || response.data.error=="tokenout"){
                        this.ordereditbusy = false
                        this.$emit('needlogin')
                    }else{
                        this.$bvModal.msgBoxOk(response.data.message, {
                            title: 'Попередження',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'bruvis',
                            okTitle: 'Ok',
                            footerClass: 'p-2',
                            hideHeaderClose: true,
                            centered: true,
                            headerClass: 'bg-danger text-white border-danger',
                        })
                        .then(value => {
                            console.log(value)
                            return
                        })
                        this.ordereditbusy = false
                    }
                }       
            })
            .catch(error => {
                this.ordereditbusy = false
                console.error('There was an error!', error)
            });
        }else{
            // remove empty order
            this.$axios.post('', {"action":"removeorder","rn":this.order2edit.rn } )
                  .then((response) => {
                    if(response.data.success != false && response.data.success != 'false'){
                        this.$emit('onsuccess')
                        this.ordereditbusy = false
                        this.$toasted.success(response.data.message).goAway(3000)
                        this.$emit('close')
                    }else{
                      this.ordereditbusy = false
                      if(response.data.error=="auth" || response.data.error=="tokenout"){
                        this.ordereditbusy = false
                        this.$emit('needlogin')
                      }else{
                        this.$toasted.error(response.data.message).goAway(3000) 
                      }
                    }  
                  })
                  .catch(error => {
                    this.ordersbusy = false
                    console.error('There was an error!', error)
                  });

        }    

    },
    recalcAmountSum() {
       var amnt = 0
       var complexlimitmp = 0
       this.order.forEach((itm) => {
            if(this.dishes[itm.menu_rn]){
                if((this.dishes[itm.menu_rn]).priceIncludingDiscount > 0){
                    amnt += (this.dishes[itm.menu_rn]).priceIncludingDiscount * itm.quant
                }else{    
                    amnt += (this.dishes[itm.menu_rn]).price * itm.quant
                }
                if(this.dishes[itm.menu_rn].complex  && itm.quant > 0) complexlimitmp += itm.quant
            }        
        })
        this.exceed = (amnt > this.sumlimit)
        this.exceedCardLimit = (amnt > this.cardlimit && this.cardlimit > 0)
        this.amount_sum = amnt
        this.complexlimit = complexlimitmp
      return true
    },
    openSimpleMenu(){
        this.$bvModal.show('simplemenu')
    },
    addToOrder(){
        var or,flag,ordernew1=this.order,ordernew2=[],ordertmp=[]

        this.selected.forEach((s)=>{
            flag=false

            ordernew1.forEach((o)=>{
                if(o.menu_rn==s){
                    flag=true    
                    if(o.quant == 0)o.quant = 1
                    else o.quant++
                }
                ordertmp.push(o)     
            })    

            ordernew1 = ordertmp
            ordertmp = []

            if(!flag){
                or={
                    "rn":"00000",
                    "menu_rn": s,
                    "menu": this.menu_dishes[s].mnemo,
                    "quant": 1,
                    "price": this.menu_dishes[s].price
                }
                ordernew2.push(or)
            }    




/*
            ordertmp.forEach((o)=>{
                if(o.menu_rn==s){
                    flag=true    
                    if(o.quant == 0)o.quant = 1
                }
                ordernew1.push(o)     
            })
            ordertmp = ordernew1
            if(!flag){
                or={
                    "rn":"00000",
                    "menu_rn": s,
                    "menu": this.menu_dishes[s].mnemo,
                    "quant": 1,
                    "price": this.menu_dishes[s].price
                }
                ordernew2.push(or)
            }    
*/                
        })
        console.log(ordernew1,ordernew2)
        this.order = [...ordernew1, ...ordernew2]
        console.log('Result',this.order)
        this.selected = []
        this.complexlimitselected = 0
        this.recalcAmountSum()
    },
    setItemQuant(rn,q){
        var n=[]
        this.order.forEach((o)=>{
            if(rn==o.menu_rn) o.quant=q
            n.push(o)
        })
        this.order = n
        this.recalcAmountSum()
    }

  },
  watch: {
    catIndex(c){
        var menu_tmp = []
        Object.values(this.menu_dishes).forEach((d) =>{
            if(this.menu_categories[c].childs.indexOf(d.rp)!==-1) menu_tmp.push(d)
        })

        this.menu_filtered = this._.orderBy(menu_tmp, 'mnemo', 'asc')
        //this.menu_filtered = menu_tmp
    },
    order(o){
        this.oarr = o.filter(item => item.quant > 0).map(x => x.menu_rn)
    },
    selected(sel){
        var complexlimitmp = (sel.length>0)?this.complexlimit:0
        sel.forEach((s)=>{
            if(this.dishes[s].complex) complexlimitmp++
        })
        this.complexlimitselected = complexlimitmp
    }
  },
  computed: {

    
  }  
}
</script>

<style scoped>
.wrdwrp{
    word-break: break-all;
}
.modal-backdrop {
  background-color: #6c757de6 !important;
  opacity: 1 !important;
}

</style>
